import { render, staticRenderFns } from "./MarketHoursCard.vue?vue&type=template&id=38626a62&scoped=true"
import script from "./MarketHoursCard.vue?vue&type=script&lang=js"
export * from "./MarketHoursCard.vue?vue&type=script&lang=js"
import style0 from "./MarketHoursCard.vue?vue&type=style&index=0&id=38626a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38626a62",
  null
  
)

export default component.exports